import React, { useState } from 'react';
import { apiLogin, apiTeacherLogin } from '../storage';

function LockScreen({ user, role, activeSessionId, onUnlock, onLogout }) {
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const [loading, setLoading] = useState(false);
  const MAX_ATTEMPTS = 5;
  const remaining = MAX_ATTEMPTS - attempts;

  const tryUnlock = async () => {
    if (!pw.trim()) { setErr('Enter your password'); return; }
    if (attempts >= MAX_ATTEMPTS) { onLogout(); return; }
    setLoading(true);
    try {
      if (role === 'teacher') {
        const puser = user.puser || user.username || '';
        await apiTeacherLogin(puser, pw, activeSessionId);
      } else {
        await apiLogin(user.username, pw);
      }
      setLoading(false);
      onUnlock(true);
    } catch (e) {
      const next = attempts + 1;
      setAttempts(next);
      setPw('');
      setLoading(false);
      if (next >= MAX_ATTEMPTS) {
        setErr('Too many failed attempts. Signing out for security.');
        setTimeout(() => onLogout(), 2000);
      } else {
        setErr(`Incorrect password. ${MAX_ATTEMPTS - next} attempt${MAX_ATTEMPTS - next !== 1 ? 's' : ''} remaining.`);
      }
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'linear-gradient(145deg,#001530,#002045)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999, fontFamily: 'Inter,sans-serif' }}
      // Prevent right-click / inspect shortcuts on lock screen
      onContextMenu={e => e.preventDefault()}>
      <div style={{ width: '100%', maxWidth: 360, padding: '36px 32px', borderRadius: 20, background: 'rgba(255,255,255,0.06)', border: '1.5px solid rgba(255,255,255,0.12)', backdropFilter: 'blur(20px)', boxShadow: '0 24px 60px rgba(0,0,0,0.5)', textAlign: 'center' }}>
        <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'linear-gradient(135deg,#1960a3,#60a5fa)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', boxShadow: '0 8px 24px rgba(25,96,163,0.4)' }}>
          <span className="material-symbols-outlined" style={{ fontSize: 30, color: '#fff', fontVariationSettings: "'FILL' 1" }}>lock</span>
        </div>
        <div style={{ fontSize: 18, fontWeight: 800, color: '#fff', marginBottom: 4 }}>Session Locked</div>
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.45)', marginBottom: 24 }}>Locked due to inactivity. Enter your password to continue.</div>
        <div style={{ fontSize: 12, fontWeight: 700, color: 'rgba(255,255,255,0.6)', marginBottom: 6, textAlign: 'left' }}>
          {user?.name || user?.username}
        </div>
        {err && <div style={{ background: 'rgba(239,68,68,0.15)', color: '#fca5a5', borderRadius: 10, padding: '8px 12px', fontSize: 12, fontWeight: 600, marginBottom: 12, border: '1px solid rgba(239,68,68,0.3)' }}>{err}</div>}
        {attempts > 0 && attempts < MAX_ATTEMPTS && (
          <div style={{ background: 'rgba(251,191,36,0.1)', color: '#fbbf24', borderRadius: 10, padding: '6px 12px', fontSize: 11, fontWeight: 600, marginBottom: 12, border: '1px solid rgba(251,191,36,0.2)' }}>
            ⚠️ {remaining} attempt{remaining !== 1 ? 's' : ''} left before auto sign-out
          </div>
        )}
        <div style={{ position: 'relative', marginBottom: 16 }}>
          <span className="material-symbols-outlined" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', fontSize: 18, color: '#94a3b8', pointerEvents: 'none' }}>lock</span>
          <input value={pw} onChange={e => { setPw(e.target.value); setErr(''); }} type={showPw ? 'text' : 'password'}
            placeholder="Enter password" onKeyDown={e => e.key === 'Enter' && !loading && tryUnlock()} autoFocus
            disabled={attempts >= MAX_ATTEMPTS || loading}
            style={{ width: '100%', padding: '12px 42px', borderRadius: 12, border: '1.5px solid rgba(255,255,255,0.15)', background: 'rgba(255,255,255,0.07)', fontSize: 13, color: '#fff', outline: 'none', boxSizing: 'border-box', opacity: attempts >= MAX_ATTEMPTS ? 0.5 : 1 }} />
          <button onClick={() => setShowPw(v => !v)} tabIndex={-1} style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', padding: 2, display: 'flex', alignItems: 'center' }}>
            <span className="material-symbols-outlined" style={{ fontSize: 18 }}>{showPw ? 'visibility_off' : 'visibility'}</span>
          </button>
        </div>
        <button onClick={tryUnlock} disabled={loading || attempts >= MAX_ATTEMPTS}
          style={{ width: '100%', padding: '13px', borderRadius: 12, border: 'none', background: 'linear-gradient(135deg,#002045,#1960a3)', color: '#fff', fontWeight: 800, fontSize: 14, cursor: 'pointer', marginBottom: 12, boxShadow: '0 4px 16px rgba(25,96,163,0.35)', opacity: loading || attempts >= MAX_ATTEMPTS ? 0.6 : 1 }}>
          {loading ? 'Verifying…' : 'Unlock'}
        </button>
        <button onClick={onLogout} style={{ width: '100%', padding: '10px', borderRadius: 12, border: '1.5px solid rgba(255,255,255,0.12)', background: 'transparent', color: 'rgba(255,255,255,0.45)', fontWeight: 600, fontSize: 12, cursor: 'pointer' }}>
          Sign out instead
        </button>
      </div>
    </div>
  );
}

export default LockScreen;
